import { render } from "./AveriasChart.vue?vue&type=template&id=48a74604&scoped=true"
import script from "./AveriasChart.vue?vue&type=script&lang=js"
export * from "./AveriasChart.vue?vue&type=script&lang=js"

import "./AveriasChart.vue?vue&type=style&index=0&id=48a74604&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/Laravel/mistock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a74604"]])

export default __exports__